import { Fragment } from "react";
import $i18n from "../locales/i18n";
import React, { useCallback, useEffect, useState } from 'react';
import ReactDom from 'react-dom';
import { errorLevelIconEnum } from "../const";
import "./style.scss";
var emptyFn = function emptyFn() {};
export default {
  show: function show(infoConfig) {
    if (infoConfig === void 0) {
      infoConfig = {};
    }
    if (!window.CNUI || !window.CNUI.CnDialog) {
      console.error('CnErrorFeedback: CNUI is not defined, please import CNUI first');
      return null;
    }
    var _ref = window.CNUI || {},
      CnDialog = _ref.CnDialog,
      CnMessage = _ref.CnMessage,
      CnDrawer = _ref.CnDrawer,
      CnButton = _ref.CnButton,
      CnIcon = _ref.CnIcon;
    var Dialog = function Dialog(_ref2) {
      var _ref2$config = _ref2.config,
        config = _ref2$config === void 0 ? {} : _ref2$config,
        _ref2$onClose = _ref2.onClose,
        onClose = _ref2$onClose === void 0 ? emptyFn : _ref2$onClose;
      var _ref3 = config,
        _ref3$errorContentInf = _ref3.errorContentInfo,
        _ref3$errorContentInf2 = _ref3$errorContentInf === void 0 ? {} : _ref3$errorContentInf,
        errorTitle = _ref3$errorContentInf2.errorTitle,
        _ref3$errorContentInf3 = _ref3$errorContentInf2.errorLevel,
        errorLevel = _ref3$errorContentInf3 === void 0 ? 'warning' : _ref3$errorContentInf3,
        confirmTexts = _ref3$errorContentInf2.confirmTexts,
        confirmUrl = _ref3$errorContentInf2.confirmUrl,
        _ref3$errorSolution = _ref3.errorSolution,
        _ref3$errorSolution2 = _ref3$errorSolution === void 0 ? {} : _ref3$errorSolution,
        _ref3$errorSolution2$ = _ref3$errorSolution2.enableSolution,
        enableSolution = _ref3$errorSolution2$ === void 0 ? false : _ref3$errorSolution2$,
        solutionType = _ref3$errorSolution2.solutionType,
        textReason = _ref3$errorSolution2.textReason,
        textSolution = _ref3$errorSolution2.textSolution,
        text = _ref3$errorSolution2.text,
        manualUrl = _ref3$errorSolution2.manualUrl,
        errorMsg = _ref3.errorMsg,
        errorCode = _ref3.errorCode;
      var _useState = useState(false),
        visible = _useState[0],
        setVisible = _useState[1];
      var _useState2 = useState(false),
        fl = _useState2[0],
        setFl = _useState2[1];
      var _useState3 = useState(true),
        dialogVisible = _useState3[0],
        setDialogVisible = _useState3[1];
      var _useState4 = useState(),
        feedbackIcon = _useState4[0],
        setFeedbackIcon = _useState4[1];
      var _useState5 = useState(false),
        hasFeedback = _useState5[0],
        setHasFeedback = _useState5[1];
      var iframeFinal = function iframeFinal() {
        return !fl && (setFl(true), setVisible(false));
      };
      useEffect(function () {
        setTimeout(function () {
          return setVisible(enableSolution && solutionType === 'iframe');
        });
      }, []);
      var closeDrawer = useCallback(function () {
        setVisible(false);
      }, []);
      var feedbackAction = function feedbackAction(type) {
        try {
          var _window, _window$trace, _window2, _window2$trace;
          if (hasFeedback) return;
          ((_window = window) === null || _window === void 0 ? void 0 : (_window$trace = _window.trace) === null || _window$trace === void 0 ? void 0 : _window$trace.logCustom) && ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$trace = _window2.trace) === null || _window2$trace === void 0 ? void 0 : _window2$trace.logCustom({
            p1: 'errorCodeFeedback',
            c8: errorMsg,
            c9: errorCode,
            c10: type
          }));
          setFeedbackIcon(type);
          setHasFeedback(true);
          CnMessage.show($i18n.get({
            id: 'ThankYouForYourFeedback',
            dm: '谢谢您的反馈！'
          }));
        } catch (error) {
          // do nothing
        }
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CnDialog, {
        className: "cn-error-feedback-dialog",
        visible: dialogVisible,
        okProps: {
          children: confirmTexts,
          visible: !!confirmTexts
        },
        onOk: function onOk() {
          confirmUrl && window.open(confirmUrl);
          setDialogVisible(false);
        },
        afterClose: onClose,
        onClose: function onClose() {
          return setDialogVisible(false);
        },
        onCancel: function onCancel() {
          return setDialogVisible(false);
        },
        footer: /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            marginTop: 6
          }
        }, /*#__PURE__*/React.createElement("span", null, $i18n.get({
          id: 'IsItHelpful',
          dm: '是否有帮助'
        })), /*#__PURE__*/React.createElement(CnIcon, {
          onClick: function onClick() {
            feedbackAction('good');
          },
          style: {
            margin: '0 16px',
            cursor: 'pointer'
          },
          type: feedbackIcon === 'good' ? 'icon-good-fill' : 'icon-good'
        }), /*#__PURE__*/React.createElement(CnIcon, {
          onClick: function onClick() {
            feedbackAction('bad');
          },
          style: {
            rotate: '180deg',
            cursor: 'pointer'
          },
          type: feedbackIcon === 'bad' ? 'icon-good-fill' : 'icon-good'
        }))
      }, /*#__PURE__*/React.createElement("div", {
        className: "error-message-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title",
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement(CnIcon, {
        type: errorLevelIconEnum[errorLevel].icon,
        size: "xl",
        style: {
          color: errorLevelIconEnum[errorLevel].color
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 18,
          color: '#333',
          fontWeight: 500,
          marginLeft: 4
        }
      }, errorTitle)), /*#__PURE__*/React.createElement("div", {
        className: "content",
        style: {
          color: '#333',
          fontSize: 12,
          lineHeight: '18px',
          marginTop: 16,
          paddingLeft: 28
        }
      }, /*#__PURE__*/React.createElement("p", null, errorMsg), enableSolution && solutionType && (solutionType === 'text' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, textReason), /*#__PURE__*/React.createElement("p", null, textSolution)) : /*#__PURE__*/React.createElement(CnButton, {
        type: "primary",
        text: true,
        onClick: function onClick() {
          if (solutionType === 'hyperlink') {
            window.open(manualUrl);
          } else {
            setVisible(true);
            setFl(true);
          }
        }
      }, text))))), /*#__PURE__*/React.createElement(CnDrawer, {
        visible: visible,
        popupContainer: document.body,
        title: $i18n.get({
          id: 'Solution',
          dm: '解决方案'
        }),
        size: "large",
        footer: true,
        style: {
          display: fl ? 'block' : 'none'
        },
        hasMask: fl,
        okProps: {
          visible: false
        },
        cache: true,
        onOk: closeDrawer,
        onClose: closeDrawer,
        onCancel: closeDrawer
      }, manualUrl && /*#__PURE__*/React.createElement("iframe", {
        onError: iframeFinal,
        onLoad: iframeFinal,
        style: {
          border: 'none',
          height: '83vh'
        },
        width: "100%",
        src: manualUrl
      })));
    };
    var _infoConfig = infoConfig,
      _infoConfig$errorCont = _infoConfig.errorContentInfo,
      _infoConfig$errorCont2 = _infoConfig$errorCont === void 0 ? {} : _infoConfig$errorCont,
      displayMode = _infoConfig$errorCont2.displayMode,
      errorTitle = _infoConfig$errorCont2.errorTitle,
      _infoConfig$errorCont3 = _infoConfig$errorCont2.errorLevel,
      errorLevel = _infoConfig$errorCont3 === void 0 ? 'warning' : _infoConfig$errorCont3,
      errorMsg = _infoConfig.errorMsg;
    switch (displayMode) {
      case 'dialog':
        {
          var div = document.createElement('div');
          var unmount = function unmount() {
            var _div$parentNode;
            ReactDom.unmountComponentAtNode(div);
            (_div$parentNode = div.parentNode) === null || _div$parentNode === void 0 ? void 0 : _div$parentNode.removeChild(div);
          };
          document.body.append(div);
          ReactDom.render(/*#__PURE__*/React.createElement(Dialog, {
            config: infoConfig,
            onClose: unmount
          }), div);
          return {
            close: unmount
          };
        }
      case 'tips':
        {
          CnMessage[errorLevel]({
            title: errorTitle,
            content: errorMsg
          });
          return {
            close: CnMessage.hide
          };
        }
      default:
        return null;
    }
  }
};